import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import ThemeContext from "../../Context/theme/ThemeContext";
import { trimDescription } from "../../Files/UseFunction";
import ProfilePic from "./ProfilePic";

const GigsCart = ({ item }) => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  return (
    <div
      className={`  rounded-2xl flex flex-col gap-4 font-pop py-2 px-4
             ${theme == "dark" ? "bg-black text-white" : "bg-white "} `}
      onClick={() => {
        navigate(`/user-dashboard/service/service_detail/${item?.User?._id}`);
      }}
    >
      <div className="flex flex-row justify-between">
        <div className="flex gap-2">
          <div className="w-12 h-12 rounded-full overflow-hidden">
            <ProfilePic
              profilePhoto={item?.User?.ProfilePhoto}
              name={item?.User?.FirstName}
            />
          </div>
          <div className="flex flex-col gap-0">
            <div className="flex flex-row gap-1 items-center">
              {item?.BusinessAccount =="Approve" && (
                <img src="../../../../Assets/Prop/badge.png" className="w-4 h-4" />
              )}
              <h4
                className={` text-lightGrey   ${
                  theme == "dark" && "text-white"
                } `}
              >
                Level {item?.Level}
              </h4>
            </div>
            <h3 className="text-lg font-semibold">
              {item?.User?.FirstName} {item?.User?.LastName}
            </h3>
          </div>
        </div>
        <div className="bg-[#FEF8EE] py-1 px-2 h-fit text-[#F9B754] rounded-3xl">
          {item?.Rating}
        </div>
      </div>
      <div className="flex flex-row font-pop gap-1">
        {item?.Keywords?.slice(0, 2).map((item2, index2) => (
          <div
            className={` bg-[#EFFBF1] rounded-full py-1 px-2 text-sm
                     ${theme == "dark" ? "bg-black text-white" : "bg-white "} `}
            key={index2}
          >
            {item2}
          </div>
        ))}
        {item?.Keywords?.length > 2 && (
          <div
            className={`  bg-[#EFFBF1] rounded-full p-1 text-sm
                     ${theme == "dark" ? "bg-black text-white" : "bg-white "} `}
          >
            +{item?.Keywords?.length - 2}
          </div>
        )}
      </div>
      <div className="flex flex-col gap-2 h-full">
        <h2 className="font-medium ">{trimDescription(item?.Title)}</h2>
        <div className="flex w-full h-full flex-row justify-between gap-2">
          {item?.Images?.map((item2, index2) => (
            <img
              src={item2?.img}
              alt=""
              className="w-[30%] object-cover rounded-2xl bg-gray-100 h-full"
              key={index2}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GigsCart;
